import React from 'react';

import PropertyComps from './index';

export default function SalePropertyComps(props) {
  return <PropertyComps {...props} type="sale" />;
}
